import { RowAdministratorRechargerDto } from "@/dtos";
import { AdministratorRecharger } from "@/entities";

export const formatRowAdministratorRechargerDto = (administratorRechargers: AdministratorRecharger[]): RowAdministratorRechargerDto[] => {
    return administratorRechargers.map(x => {
        const row: RowAdministratorRechargerDto = {
            ...x,
            recharger: x.detail.recharger,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}